var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 py-1 cursor-pointer hover:bg-gray-500 border-green-600",class:_vm.active ? 'border-b-4' : 'border-none',on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }